export const globalConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
};

if (typeof window.globalConfig === "object") {
  Object.assign(globalConfig, window.globalConfig);
}

export default globalConfig;
